export default __webpack_public_path__ + "static/media/Logo-eKYC.5aaae33d.png";